import axios from '../axios'
import { API_BASE_URL } from '../constants'

export default function logout() {
  return axios.post(`${API_BASE_URL}/logout`).then((response) => response.data)
}
